import tns from "@/lib/tiny-slider/tiny-slider.js";

document.addEventListener('DOMContentLoaded', function () {
    var sliderInstance = null;

    // Open popup and clone content
    document.querySelectorAll('.room-popup-open-link').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            var popup = btn.parentElement ? btn.parentElement.querySelector('.room-popup-item') : null;
            if (!popup) {
                // fallback: sibling
                popup = btn.nextElementSibling && btn.nextElementSibling.classList.contains('room-popup-item') ? btn.nextElementSibling : popup;
            }

            if (popup) {
                var clonedPopup = popup.cloneNode(true); // events not copied; we use delegation
                var inner = document.querySelector('.room-popup-inner');
                if (!inner) return;
                // clear previous content just in case
                inner.innerHTML = '';
                inner.appendChild(clonedPopup);

                // init tiny-slider on any gallery-slider inside cloned popup
                var containerEl = clonedPopup.querySelector('.gallery-slider');
                if (containerEl) {
                    sliderInstance = tns({
                        container: containerEl,
                        items: 1,
                        slideBy: 1,
                        nav: false,
                        controls: false,
                        autoplay: false,
                        speed: 300
                    });

                    var prev = clonedPopup.querySelector('.left-arrow') || clonedPopup.querySelector('.slick-prev');
                    var next = clonedPopup.querySelector('.right-arrow') || clonedPopup.querySelector('.slick-next');

                    if (prev) prev.addEventListener('click', function (ev) { ev.preventDefault(); sliderInstance.goTo('prev'); });
                    if (next) next.addEventListener('click', function (ev) { ev.preventDefault(); sliderInstance.goTo('next'); });
                }

                // activate first tab
                var firstTab = clonedPopup.querySelector('ul.room-popup-tabs li:first-child');
                if (firstTab) firstTab.classList.add('active');

                document.body.classList.add('stopscroll');
                var roomPopup = document.querySelector('.room-popup');
                if (roomPopup) roomPopup.classList.add('active');
            }
        });
    });

    // Delegated click handler for popup inner (handles tabs, close, rfp links)
    var popupInner = document.querySelector('.room-popup-inner');
    if (popupInner) {
        popupInner.addEventListener('click', function (e) {
            var li = e.target.closest('ul.room-popup-tabs li');
            if (li && popupInner.contains(li)) {
                e.preventDefault();
                if (li.classList.contains('rfp-link')) {
                    ClosePopup();

                    var bookRow = document.getElementById('roomBookRow');
                    if (bookRow) {
                        var top = bookRow.getBoundingClientRect().top + window.pageYOffset - 50;
                        window.scrollTo({ top: top, behavior: 'smooth' });
                    }

                    var a = li.querySelector('a');
                    var hotelId = a ? a.dataset.hotel : null;
                    if (hotelId) {
                        var sel = document.getElementById('hotelFormSelect');
                        if (sel) {
                            sel.value = hotelId;
                            sel.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }

                    return;
                }

                var a = li.querySelector('a');
                var activeTab = a ? (a.dataset.tab || a.getAttribute('data-tab')) : null;

                // remove active from all tabs (scope to current popup)
                var allTabs = document.querySelectorAll('ul.room-popup-tabs li');
                allTabs.forEach(function (t) { t.classList.remove('active'); });
                li.classList.add('active');

                // switch content
                document.querySelectorAll('.room-popup-inner .room-popup-content').forEach(function (c) { c.classList.remove('active'); });
                if (activeTab) {
                    var target = document.querySelector('.room-popup-inner .room-popup-content[data-tab="' + activeTab + '"]');
                    if (target) target.classList.add('active');
                }

                // reinit or refresh slider if gallery tab
                if (activeTab === 'roomt-gallery' && sliderInstance) {
                    if (typeof sliderInstance.refresh === 'function') sliderInstance.refresh();
                    else if (typeof sliderInstance.update === 'function') sliderInstance.update();
                }

                return;
            }

            var closeBtn = e.target.closest('.room-popup-close');
            if (closeBtn && popupInner.contains(closeBtn)) {
                e.stopPropagation();
                ClosePopup();
                return;
            }
        });
    }

    function ClosePopup() {
        var roomPopup = document.querySelector('.room-popup');
        if (roomPopup) roomPopup.classList.remove('active');
        document.body.classList.remove('stopscroll');
        // wait a few milliseconds before we clear the popup content to give it time to disappear from screen
        setTimeout(function () {
            var inner = document.querySelector('.room-popup-inner'); if (inner) inner.innerHTML = '';
            // destroy tiny-slider instance if present
            try { if (sliderInstance && typeof sliderInstance.destroy === 'function') sliderInstance.destroy(); } catch (e) { /* ignore */ }
            sliderInstance = null;
        }, 300);
    }

});



